import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="documents"
export default class extends Controller {

  static targets = ["file", "folder"]

  changeFolder(event) {
    const searchValue = document.querySelector('#document-search').value.toLowerCase()
    this.showHideDocuments(event.target.dataset['folder'], searchValue)
  }

  newGroups(event){
    const checked = event.target.checked
    if(checked){
      this.fileTargets.forEach((file) => {
        if(file.textContent.includes('NEW')){
          this.adjustHidden(file, false)
        }else{
          this.adjustHidden(file, true)
        }
      })
    }else{
     this.fileTargets.forEach((file) => {
        this.adjustHidden(file, false)
      })
    }
  }

  async checkedProposals(event){
    const url = event.target.dataset.url
    const checked = event.target.checked
    if(checked){
      if(url){
        const response = await get(url)
        if (response.ok){
          let ids = await response.json
          this.fileTargets.forEach((file) => {
            if(ids.includes(file.id)){
              this.adjustHidden(file, false)
            }else{
              this.adjustHidden(file, true)
            }
          })
        }
      }
    }else{
      this.fileTargets.forEach((file) => {
        this.adjustHidden(file, false)
      })
    }
  }

  adjustHidden(element, hidden) {
    element.classList.toggle('hidden', hidden);
    element.hidden = hidden;
  }

  showHideDocuments(folderName, searchValue){
    this.fileTargets.forEach((file) => {
      if (folderName === "ALL"){
        this.search(file, searchValue)
      } else {
        if (file.dataset['folder'] === folderName) {
          this.search(file, searchValue)
        } else {
          this.adjustHidden(file, true)
        }
      }
    })
  }

  searchField(event){
    const folder = document.querySelector('.nav-link.active')
    let folderName
    if (folder){
      folderName = folder.dataset['folder']
    } else {
      folderName = 'ALL'
    }
    this.showHideDocuments(folderName, event.target.value.toLowerCase())
  }

  search(file, searchValue) {
    if (file.textContent.toLowerCase().includes(searchValue)) {
      this.adjustHidden(file, false)
    }else{
      this.adjustHidden(file, true)
    }
  }

}
